// utils/geolocation.js
export const getUserLocation = () =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      return reject(new Error('Geolocation is not supported'));
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy, // Optional: expose for debugging
        });
      },
      (error) => reject(error),
      {
        enableHighAccuracy: true,
        timeout: 10000,       // Wait up to 10 seconds
        maximumAge: 0         // No cached position
      }
    );
  });
